var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#4BB378",
    stroke: "#4BB378"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86402 11.0448C8.73718 10.9134 8.58546 10.8087 8.4177 10.7366C8.24995 10.6646 8.06952 10.6266 7.88695 10.6251C7.70438 10.6235 7.52332 10.6583 7.35433 10.7274C7.18535 10.7965 7.03183 10.8986 6.90273 11.0277C6.77363 11.1568 6.67153 11.3104 6.60239 11.4793C6.53326 11.6483 6.49847 11.8294 6.50005 12.0119C6.50164 12.1945 6.53957 12.3749 6.61163 12.5427C6.68369 12.7105 6.78845 12.8622 6.91977 12.989L9.66977 15.739C9.92762 15.9968 10.2773 16.1416 10.6419 16.1416C11.0065 16.1416 11.3562 15.9968 11.614 15.739L17.114 10.239C17.2453 10.1122 17.3501 9.96046 17.4222 9.7927C17.4942 9.62495 17.5322 9.44452 17.5337 9.26195C17.5353 9.07938 17.5005 8.89832 17.4314 8.72934C17.3623 8.56035 17.2602 8.40683 17.1311 8.27773C17.002 8.14863 16.8484 8.04653 16.6795 7.97739C16.5105 7.90826 16.3294 7.87347 16.1468 7.87505C15.9643 7.87664 15.7838 7.91457 15.6161 7.98663C15.4483 8.05869 15.2966 8.16345 15.1698 8.29477L10.6419 12.8226L8.86402 11.0448Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox_checked.998efccc1cd10566fbbd2ddcc9687e7f.svg";
export { ForwardRef as ReactComponent };